import React, { useEffect, lazy, Suspense } from "react";
import { useDispatch } from "react-redux";
import { fetchReports } from "../../store/researchReportSlice";
import { fetchIndustries } from "../../store/industrySlice";
import { SeoManager } from "../../common/SeoManager";
import HeroSection from "./components/HeroSection";
import ValuePropSection from "./components/ValuePropSection";
import IndustriesSection from "./components/IndustriesSection";
import FeaturedResearchSection from "./components/FeaturedResearchSection";
import "./HomePage.scss";

const BusinessQuestionsSection = lazy(
  () => import("./components/BusinessQuestionsSection"),
);
const ResearchSolutionsSection = lazy(
  () => import("./components/ResearchSolutionsSection"),
);
const AwardsSection = lazy(() => import("./components/AwardsSection"));
const FaqSection = lazy(() => import("./components/FaqSection"));
const CtaSection = lazy(() => import("./components/CtaSection"));

const HomePage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchReports({ force: false }));
    dispatch(fetchIndustries());
  }, [dispatch]);

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Researchwire Market",
    url: "https://www.rwmarketintelligence.com",
    logo: "https://www.rwmarketintelligence.com/Rwirelogo.png",
  };

  return (
    <div className="home-page">
      <SeoManager
        title="Home"
        description="Discover how Researchwire Market Intelligence Platform can help your business with strategic insights, GTM strategies, and competitive intelligence."
        ogTitle="Researchwire Market Intelligence Platform"
        schema={organizationSchema}
      />
      <HeroSection />
      <IndustriesSection />
      <FeaturedResearchSection />
      <ValuePropSection />

      <Suspense fallback={<div style={{ minHeight: "200px" }} />}>
        <BusinessQuestionsSection />
        <ResearchSolutionsSection />
        <AwardsSection />
        <FaqSection />
        <CtaSection />
      </Suspense>
    </div>
  );
};

export default HomePage;
